import { Format } from './format.interface';
import { Card, Query } from '@deckplan.io/common';

export class Pauper extends Format {

    public addCardsQuery(): Query {
        return {
            dataField: {
                title: 'Legalities',
                field: 'legalities',
                dataType: 'string'
            },
            operation: 'includes',
            value: `"pauper":"legal"`
        };
    }

    public validate(): Card[] {
        return this.deck.cards.filter(c =>
            // All cards not legal in pauper are invalid
            c.legalities.pauper === 'not_legal'
        );
    }

}
